// Extract YouTube video ID from any of the URL forms used in the codebase:
//   https://www.youtube.com/watch?v=ID
//   https://www.youtube.com/embed/ID
//   https://youtu.be/ID
//   https://www.youtube-nocookie.com/embed/ID
export function extractYoutubeId(url: string): string {
  if (!url) return "";
  const m =
    url.match(/[?&]v=([a-zA-Z0-9_-]{6,})/) ||
    url.match(/\/embed\/([a-zA-Z0-9_-]{6,})/) ||
    url.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/);
  return m ? m[1] : "";
}

type EmbedOpts = {
  start?: string | number;
  end?: string | number;
  autoplay?: boolean;
  mute?: boolean;
  loop?: boolean;
  controls?: boolean;
};

// Build the youtube-nocookie embed URL with sensible privacy + UX defaults.
// Uses youtube-nocookie.com (no cookies set until user interacts).
export function buildEmbedUrl(videoId: string, opts: EmbedOpts = {}): string {
  if (!videoId) return "";
  const params: string[] = [];
  if (opts.autoplay) params.push("autoplay=1");
  if (opts.mute) params.push("mute=1");
  if (opts.loop) {
    params.push("loop=1");
    params.push(`playlist=${videoId}`);
  }
  if (opts.start) params.push(`start=${opts.start}`);
  if (opts.end) params.push(`end=${opts.end}`);
  if (opts.controls === false) params.push("controls=0");
  // Privacy + minimal chrome
  params.push("modestbranding=1");
  params.push("rel=0");
  params.push("iv_load_policy=3");
  params.push("fs=1");
  params.push("playsinline=1");
  return `https://www.youtube-nocookie.com/embed/${videoId}?${params.join("&")}`;
}
